jQuery(($) => {

    if ($('.o-cta-blocks-slider')[0]) {
        var dotsNavigation   = $('.o-cta-blocks-slider__dots-navigation'),
            arrowsNavigation = $('.o-cta-blocks-slider__arrows-navigation');

        $('.o-cta-blocks-slider .o-cta-blocks-slider__slides').slick({
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            appendDots: dotsNavigation,
            appendArrows: arrowsNavigation,
            responsive: [{
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ]
        });
    } 
}); 